import { loadBurstPair, type FlowThemeDefinition } from '../../definition';
import { oceanCardMotion } from './motion';
import { oceanChromeTone } from './palette';

export const oceanTheme: FlowThemeDefinition = {
  id: 'ocean',
  label: 'Deep Dive',
  description: 'Each step sinks one zone deeper, from sunlit water to a glowing abyss where a whale glides by.',
  category: 'classic',
  chromeTone: oceanChromeTone,
  swatch: 'linear-gradient(180deg, #A6E6E6 0%, #22709E 55%, #081F45 100%)',
  cardGlass: 'dense',
  cardMotion: oceanCardMotion,
  burstSize: 320,
  softwareFriendly: false,
  loadScene: () => import('./scene').then((module) => module.createOceanScene),
  loadBursts: () => loadBurstPair(import('./burst-step.json'), import('./burst-finale.json')),
};
